<script setup lang="ts">
import {defineProps, withDefaults} from "vue";
import type {IDocsListItem} from "~/components/docs/types";
import Sprites from "~/components/icon/Sprites.vue";

const $props = withDefaults(defineProps<{
  items: IDocsListItem[]
}>(), {
  items: () => ([])
})
const ITEMS_FILTERED = computed(() => $props.items.filter(i => !!i.demo));
</script>

<template>
  <ul class="docs-list">
    <li class="docs-list-item"
      v-for="(item, index) in ITEMS_FILTERED"
      :key="`doc-list-item-${index}`"
    >
      <div class="docs-list-item-title">
        <span class="name" v-if="!!item.name" v-html="item.name"></span>
        <span class="icon" v-if="!!item.icon" v-html="item.icon"></span>
      </div>

      <div v-if="!!item.description" class="docs-list-item-description" v-html="item.description"></div>
      <div v-if="!!item.demo?.login || item?.demo?.password" class="docs-list-item-login">
        <template v-if="!!item?.demo?.login">
          <p>Login: <span v-html="item.demo.login"></span></p>
        </template>
        <template v-if="!!item?.demo?.password">
          <p>Password: <span v-html="item.demo.password"></span></p>
        </template>
      </div>

      <a :href="item.demo?.link" class="btn" target="_blank">
        Перейти
        <icon name="icon-arrow-right-link"/>
      </a>
    </li>
  </ul>


  <sprites>
    <symbol id="icon-doc-link" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="10" fill="#5667FF"/>
      <path d="M8 6L12 10L8 14" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </symbol>
    <symbol id="icon-arrow-right-link" viewBox="0 0 20 13" fill="none">
      <path d="M19.5303 7.03033C19.8232 6.73744 19.8232 6.26256 19.5303 5.96967L14.7574 1.1967C14.4645 0.903806 13.9896 0.903806 13.6967 1.1967C13.4038 1.48959 13.4038 1.96447 13.6967 2.25736L17.9393 6.5L13.6967 10.7426C13.4038 11.0355 13.4038 11.5104 13.6967 11.8033C13.9896 12.0962 14.4645 12.0962 14.7574 11.8033L19.5303 7.03033ZM0 7.25H19V5.75H0V7.25Z" fill="white"/>
    </symbol>
  </sprites>
</template>

<style scoped lang="scss">
.docs-list {
  --gap: 40px;
  --items-count: 3;
  display: flex;
  flex-wrap: wrap;
  gap: var(--gap);

  @include onLG {
    --items-count: 2;
    --gap: 25px
  }

  @include onSM {
    --items-count: 1;
    --gap: 20px
  }

  .docs-list-item {
    width: calc((100% / var(--items-count)) - (var(--gap) - (var(--gap) / var(--items-count))));
    border-radius: var(--main-border-radius);
    background: $GRAY_TEXT_LIGHT;
    padding: 25px;
    flex-grow: 1;
    transition: all .25s ease;

    &--fluid {
      @extend .docs-list-item;
      align-items: flex-start;
      width: calc(100% - (100% / var(--items-count)) - (var(--gap) - (var(--gap) / (var(--items-count) - 1.3) )));

      .static-text {
        text-align: left;
        @include font-size(18px);
        --min-font-size: 16px;
        font-weight: 400;
        line-height: 1.5em;
        letter-spacing: -0.72px;
        &:has(+*) {
          margin-bottom: 20px;
        }
      }
    }

    &-title {
      color: $GRAY_TEXT_DARK;
      @include font-size(28px);
      --min-font-size: 25px;
      font-weight: 600;
      line-height: 1.2em;
      letter-spacing: -1.12px;
      display: flex;
      gap: 13px;
      margin-bottom: 20px;
    }


    &-description {
      color: $GRAY_TEXT_DARK;
      @include font-size(15px);
      --min-font-size: 13px;
      font-weight: 400;
      line-height: 1.5em;
      letter-spacing: -0.6px;
      margin-bottom: 10px;
    }

    &-login {
      color: $GRAY_TEXT_DARK;
      @include font-size(20px);
      font-weight: 600;
      line-height: 1.5em;
      letter-spacing: -0.8px;
      margin-bottom: 20px;
    }

    .btn {
      display: inline-flex;
      padding: 12px 20px;
      @include font-size(16px);
      font-weight: 500;
      line-height: 1.2em;
      letter-spacing: -0.64px;
      gap: 5px;
      .icon {
        width: 19px;
        height: 10px;
      }
    }
  }
}
</style>
